module.exports = __webpack_public_path__ + "static/media/veterano_p.1b41f1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/veterano_p.png
// module id = 1152
// module chunks = 0